import React from 'react'
import { atlTheme } from '../../atlTheme'
import { ATLNavigationButton } from '@appsimples/atlantica-react-native'
import { ImageSourcePropType } from 'react-native'
import { Container } from './ItemContainer'

interface ProfileNavigationItemProps {
  text: string
  onPress: () => void
  icon: ImageSourcePropType
}

export const ProfileNavigationItem: React.FunctionComponent<ProfileNavigationItemProps> = ({ text, onPress, icon }) => {
  return (
    <Container>
      <ATLNavigationButton
        text={text}
        onPressCell={onPress}
        leftIcon={icon}
        labelBaseProps={{
          fontWeight: atlTheme.FontWeight500,
        }}
        leftIconBaseProps={{
          tintColor: atlTheme.ColorBrand1Default,
        }}
      />
    </Container>
  )
}
